import { render, staticRenderFns } from "./index.vue?vue&type=template&id=629ad5b4&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629ad5b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/thScoreShop/thScoreAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('629ad5b4')) {
      api.createRecord('629ad5b4', component.options)
    } else {
      api.reload('629ad5b4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=629ad5b4&scoped=true&", function () {
      api.rerender('629ad5b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/setting/systemCreator/systemConfig/gradeConfig/index.vue"
export default component.exports